export const PATCH_ACTION = 'DomainData/Patch';
export const SUBSCRIBE_SCENE = 'DomainData/SubscribeScene';
export const SAVE_TICKERS_DETAIL = 'DomainData/Tickers/Detail';

export const SET_CURRENT_TIME = 'DomainData/CURRENT/TIME';
export const SET_CURRENT_DATE = 'DomainData/CURRENT/DATE';

export const SET_ACTIVE_COMPARATIVE_VIEW = 'DomainData/Comparative/ActiveView';
export const SAVE_COMPARATIVE_VIEW = 'DomainData/Comparative/VIEW';
export const SAVE_COMPARATIVE_DATA = 'DomainData/Comparative/Data';

export const SET_ANNOUNCEMENT_AGM_SGM = 'DomainData/Announcement/AGM_SGM';
export const SET_ANNOUNCEMENT_AUCTION = 'DomainData/Announcement/AUCTION';
export const SET_ANNOUNCEMENT_BOND_DEBENTURE = 'DomainData/Announcement/BOND_DEBENTURE';
export const SET_ANNOUNCEMENT_DIVIDEND = 'DomainData/Announcement/DIVIDEND';
export const SET_ANNOUNCEMENT_FINANCIALS = 'DomainData/Announcement/FINANCIALS';
export const SET_ANNOUNCEMENT_IPO_FPO = 'DomainData/Announcement/IPO_FPO';
export const SET_ANNOUNCEMENT_NEPSE_CIRCULAR = 'DomainData/Announcement/NEPSE_CIRCULAR';
export const SET_ANNOUNCEMENT_RIGHT_SHARES = 'DomainData/Announcement/RIGHT_SHARES';

export const SAVE_EQUITY_FINANCIALS = 'DomainData/EQUITY/FINANCIALS';
export const SAVE_EQUITY_PRICE_ACTIONS = 'DomainData/EQUITY/PRICE_ACTIONS';
export const SAVE_EQUITY_TIME_SERIES = 'DomainData/EQUITY/TIME_SERIES';
export const SAVE_EQUITY_TEARSHEET = 'DomainData/EQUITY/TEARSHEET';
export const SAVE_EQUITY_KEY_FINANCIALS = 'DomainData/EQUITY/KEY_FINANCIALS';
export const SAVE_EQUITY_DIVIDEND_HISTORY = 'DomainData/EQUITY/DIVIDEND_HISTORY';
export const SAVE_EQUITY_ANNOUNCEMENT = 'DomainData/EQUITY/ANNOUNCEMENT';
export const SET_ACTIVE_EQUITY = 'DomainData/EQUITY/ACTIVE';

export const SET_OVERVIEW_ACTIVE_SECTOR = 'DomainData/OVERVIEW/ACTIVE_SECTOR';
export const SAVE_OVERVIEW_INDICES_DATA = 'DomainData/OVERVIEW/INDICES_DATA';
export const SAVE_OVERVIEW_PRICE_ACTIONS = 'DomainData/OVERVIEW/PRICE_ACTIONS';
export const SAVE_OVERVIEW_TOP_BROKERS = 'DomainData/OVERVIEW/TOP_BROKERS';
export const SAVE_OVERVIEW_TOP_LOSERS_GAINERS = 'DomainData/OVERVIEW/TOP_LOSERS_GAINERS';
export const SAVE_OVERVIEW_ACTIVE_TURNOVER = 'DomainData/OVERVIEW/ACTIVE_TURNOVER';
export const SAVE_OVERVIEW_TIME_SERIES = 'DomainData/OVERVIEW/TIME_SERIES';
export const SAVE_OVERVIEW_SECTOR_DATA = 'DomainData/OVERVIEW/SECTOR_DATA';

export const SAVE_HOMESCREEN_TODAYS_EVENTS = 'DomainData/HOMESCREEN/TODAYS_EVENTS';
export const SAVE_HOMESCREEN_TODAYS_ANNOUNCEMENT = 'DomainData/HOMESCREEN/TODAYS_ANNOUNCEMENT';
export const SAVE_HOMESCREEN_UPCOMING_EVENTS = 'DomainData/HOMESCREEN/UPCOMING_EVENTS';
export const SAVE_HOMESCREEN_MOVERS = 'DomainData/HOMESCREEN/MOVERS';
export const SAVE_HOMESCREEN_PORTFOLIO = 'DomainData/HOMESCREEN/PORTFOLIO';
export const SAVE_HOMESCREEN_WATCHLIST_TICKERS = 'DomainData/HOMESCREEN/WATCHLIST_TICKERS';
export const SAVE_HOMESCREEN_WATCHLIST = 'DomainData/HOMESCREEN/WATCHLIST';



// WEBPACK FOOTER //
// ./src/common/action-types/domainData.js